/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import {
    Container, Card, FormControl, InputLabel, Checkbox, InputAdornment, FormHelperText, Chip
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import services from '../Services';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';


var screenCode = "COLLECTIONCENTERWISETRANSACTION"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function multiFieldComparator(a, b) {
    const dateA = new Date(a.orderDate).getTime() || 0;
    const dateB = new Date(b.orderDate).getTime() || 0;
    if (dateA !== dateB) return dateB - dateA;

    const factoryA = (a.factoryName || '').toString();
    const factoryB = (b.factoryName || '').toString();
    const factoryCompare = factoryA.localeCompare(factoryB);
    if (factoryCompare !== 0) return factoryCompare;

    const productA = (a.productName || '').toString();
    const productB = (b.productName || '').toString();
    const productCompare = productA.localeCompare(productB);
    if (productCompare !== 0) return productCompare;

    return 0;
}

function getComparator(order, orderBy) {
    return (a, b) => {
        const groupedSortResult = multiFieldComparator(a, b);
        if (groupedSortResult !== 0) return groupedSortResult;

        const fallbackResult = descendingComparator(a, b, orderBy);
        return order === 'desc' ? fallbackResult : -fallbackResult;
    };
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
       
    {
        id: 'farmerName',
        numeric: false,
        disablePadding: false,
        label: 'Farmer Name',
        align: "left"
    },
    {
        id: 'supplierCode',
        numeric: true,
        disablePadding: false,
        label: 'Supplier Code',
        align: "left"
    },    
    {
        id: 'collectionCenter',
        numeric: false,
        disablePadding: false,
        label: 'Fresh Collection Center',
        align: "left"
    },
    {
        id: 'product',
        numeric: true,
        disablePadding: false,
        label: 'Product Name',
        align: "left"
    },
    {
        id: 'orderDate',
        numeric: true,
        disablePadding: false,
        label: 'Date',
        align: "left"
    },
    {
        id: 'allocatedQuantity',
        numeric: true,
        disablePadding: false,
        label: 'Allocated Quantity',
        align: "right"
    },
    {
        id: 'quantity',
        numeric: true,
        disablePadding: false,
        label: 'Supplied Quantity',
        align: "right"
    },
];
function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));


export default function CollectionWiseTransaction(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);

    const classes = useStyles();
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('orderDate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [selectedOptions, setSelectedOptions] = useState([]);


    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Collection Center Wise Transaction'
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);

    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [vccTransaction, setVccTransaction] = useState([]);
    const sortedVccTransaction = React.useMemo(() => {
        return stableSort(vccTransaction, getComparator(order, orderBy));
    }, [vccTransaction, order, orderBy]);

    const [formData, setFormData] = useState({
        groupID: '',
        operationEntityID: '',
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
        isActive: true
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const cropAvailabilitySchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array()
            .min(1, 'Please select at least one Fresh collection center')
            .required('Please select at least one Fresh collection center'),
        toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        toDate: '',
        fromDate: ''
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isActive: formData.isActive
        },
        validationSchema: cropAvailabilitySchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'COLLECTIONCENTERWISETRANSACTION');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
    }

    async function SubmitForm() {
        let newRes = await services.CollectionCenterWiseTransaction(selectedOptions.map(x => x).join(',').toString(),
            (fromDate).toISOString(),
            (toDate).toISOString());
        let final = newRes.filter(x => x.quantity > 0)
        let res = _.cloneDeep(final);
        res.forEach(x => {
            x.orderDate = x.orderDate.split('T')[0];

        });
        setVccTransaction(res);
        createDataForExcel(res);
        getSelectedDropdownVluesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setVccTransaction([]);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setVccTransaction([]);
    }, [fromDate]);

    useEffect(() => {
        setVccTransaction([]);
    }, [toDate]);


    useEffect(() => {
        setVccTransaction([]);
    }, [selectedOptions]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions
        })
    }, [selectedOptions]);

    useEffect(() => {
        setSelectedOptions(factory.map(option => option.value));
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function clearAll() {
        if (permissionList.isFactoryFilterEnabled) {
            setVccTransaction([]);
            setValues({
                ...values,
                factoryID: '',
                statusID: '0',
                fromDate: new Date(),
                toDate: new Date(),
            })
            setSelectedOptions([]);
        } else {
            setValues({
                ...values,
                fromDate: new Date(),
                toDate: new Date(),
            })
        }
    }

    //Print
    async function createFile() {
        var file = await createDataForExcel(sortedVccTransaction);
        var settings = {
            sheetName: 'CC Wise Transaction',
            fileName: 'Collection Center Wise Transaction',
            writeOptions: {}
        }
        let tempcsvHeaders = [
            { label: 'Farmer Name', value: 'Farmer Name' },
            { label: 'Supplier Code', value: 'Supplier Code' },
            { label: 'Fresh Collection Center', value: 'Fresh Collection Center' },
            { label: 'Product', value: 'Product' },
            { label: 'Date ', value: 'Date ' },
            { label: 'Allocated Quantity(Kg) ', value: 'Allocated Quantity(Kg) ' },
            { label: 'Supplied Quantity(Kg) ', value: 'Supplied Quantity(Kg) ' }
        ];
        let dataA = [
            {
                sheet: 'CC Wise Transaction',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(
                selectedOptions.length === factory.length
                    ? []
                    : factory.map((option) => option.value)
            );
        } else {
            setSelectedOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    
                    'Farmer Name': x.firstName,
                    'Supplier Code': x.supplierCode? x.supplierCode : ' - ',
                    'Fresh Collection Center': x.factoryName,
                    'Product': x.productName,
                    'Date ': x.orderDate,
                    'Allocated Quantity(Kg) ': x.allocatedQuantity,
                    'Supplied Quantity(Kg) ': x.quantity
                }
                res.push(vr);
            });

            const totalAllocatedQuantity = array.reduce((sum, row) => sum + row.allocatedQuantity, 0);
            const totalSuppliedQuantity = array.reduce((sum, row) => sum + row.quantity, 0);

            var totalRow = {
                'Farmer Name': '',
                'Supplier Code': '',
                'Fresh Collection Center': '',
                'Product': '',
                'Date ': 'Total:',
                'Allocated Quantity(Kg) ': parseFloat(totalAllocatedQuantity.toFixed(2)),
                'Supplied Quantity(Kg) ': parseFloat(totalSuppliedQuantity.toFixed(2))
            };
            res.push(totalRow);

            res.push({});
            res.push({});

            // var vr1 = {
            //     'Farmer Name': "Group: " + selectedSearchValues.groupID,
            //     'Fresh Collection Center': "Fresh Collection Center: " + selectedSearchValues.operationEntityID,
            //     'Product': "From: " + new Date(fromDate).toISOString().split('T')[0],
            //     'Date ': "To: " + new Date(toDate).toISOString().split('T')[0]
            // }
            // res.push(vr1);
        }
        return res;
    }

    function getSelectedDropdownVluesForReport() {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });

        let groups = group.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(','),
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Collection Center Wise Transaction | FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/farmerCollectionCenterWiseTransaction"}
                        btname="Add"
                        pageName="Farmer Collection Center Wise Transaction"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>

                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center* </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            name='collectionID'
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>)}
                                    </FormControl>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Start Date *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select End Date"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Stack>
                                </Stack>
                            </Stack>
                            <br />
                            <>
                                {vccTransaction.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer>
                                                        <Table
                                                            className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            aria-label="enhanced table"
                                                        >
                                                            <EnhancedTableHead
                                                                classes={classes}
                                                                order={order}
                                                                orderBy={orderBy}
                                                                onRequestSort={handleRequestSort}
                                                                rowCount={vccTransaction.length}
                                                            />
                                                            <TableBody>
                                                                {sortedVccTransaction
                                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((row, index) => {
                                                                        const labelId = `enhanced-table-checkbox-${index}`;

                                                                        return (
                                                                            <TableRow>                                                                                                                                                        
                                                                                <TableCell component="th" id={labelId} scope="row" >
                                                                                    {row.firstName}                                                                                
                                                                                </TableCell> 
                                                                                <TableCell >{row.supplierCode? row.supplierCode: ' - '}</TableCell>                                                                                  
                                                                                <TableCell >{row.factoryName}</TableCell>
                                                                                <TableCell >{row.productName}</TableCell>
                                                                                <TableCell >{new Date(row.orderDate).toLocaleDateString('en-US',
                                                                                    { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell align='right'>{row.allocatedQuantity.toFixed(2)}</TableCell>
                                                                                <TableCell align='right'>{row.quantity.toFixed(2)}</TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                                <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                                                                    <TableCell colSpan={5} align="right" style={{ fontWeight: 'bold' }}>
                                                                        <strong>Total:</strong>
                                                                    </TableCell>
                                                                    <TableCell align='right' style={{ fontWeight: 'bold' }}>
                                                                        {vccTransaction.reduce((sum, row) => sum + row.allocatedQuantity, 0).toFixed(2)}
                                                                    </TableCell>
                                                                    <TableCell align='right' style={{ fontWeight: 'bold' }}>
                                                                        {vccTransaction.reduce((sum, row) => sum + row.quantity, 0).toFixed(2)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                        component="div"
                                                        count={vccTransaction.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Stack>
                                    </>
                                ) : null}</>
                        </Form>
                    </FormikProvider>
                    {vccTransaction.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Collection Center Wise Transaction Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={sortedVccTransaction}
                                    searchData={selectedSearchValues}

                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}